module.exports = __webpack_public_path__ + "img/c c.b7c596d6.png";